import { AppRoutes as SharedAppRoutes } from '@cfra-nextgen-frontend/shared/src/routes/AppRoutes';
import { RouteType } from '@cfra-nextgen-frontend/shared/src/routes/types';
import { setUpAwsAmplifyRememberMeListener } from '@cfra-nextgen-frontend/shared/src/routes/utils';
import { ApplicationType } from '@cfra-nextgen-frontend/shared/src/utils/enums';
import { Login } from 'features/auth/components/Login';
import { HomeRoutes } from 'features/home';
import { SnackbarProvider } from 'notistack';
import { useEffect, useRef } from 'react';
import { AuthenticatedRoutesWrapper } from 'routes/AuthenticatedRoutesWrapper';

const routes: Array<RouteType> = [{ path: '*', element: <HomeRoutes /> }];

const unauthenticatedRoutes: {
    path: string;
    element: JSX.Element;
}[] = [];

export function AppRoutes() {
    const rememberMe = useRef<boolean>();

    useEffect(() => {
        setUpAwsAmplifyRememberMeListener(rememberMe);
    }, []);

    return (
        <SharedAppRoutes
            loginElement={
                <SnackbarProvider classes={{ containerRoot: 'cfra-snackbar-root' }}>
                    <Login rememberMe={rememberMe} />
                </SnackbarProvider>
            }
            unauthenticatedRoutes={unauthenticatedRoutes}
            authenticatedRoutesJsxGetterProps={{
                authenticatedRoutesWrapperJsx: <AuthenticatedRoutesWrapper />,
                projectSpecificResources: {},
                routes,
            }}
            applicationType={ApplicationType.AccessibilityPortal}
        />
    );
}
